// @flow
import type {Publishable, PublishableOptions} from "./types.js";

type StoryStyles = "box" | "tile" | "loose" | "primary" | "secondary" | "tertiary" | "slide";
type CollectionStyles = StoryStyles | "deck" | "section" | "multislider";
export type Styles = StoryStyles | CollectionStyles;

export type Options = {
	// $FlowFixMe: WTF?
	style?: Styles;
	className?: string;
};

export type DefaultStyles = {
	story: StoryStyles;
	collection: CollectionStyles;
};

export type ItemPublishable = {
	type: "publishable";
	content: Publishable;
	options: Options;
};
export type ItemSnippet = {
	type: "snippet";
	content: string;
	options: {
		className?: string;
		inline?: boolean;
	};
};
type ItemMenu = {
	type: "menu";
	content: any;
};

export type PositionItem = ItemPublishable | ItemSnippet | ItemMenu;

export function normalizeStyle(type: "story" | "collection" | "link", style: ?string): ?Styles {
	const isStory = type === "story" || type === "link";
	switch (style) {
	case "section":
		return isStory ? null : style;
	case "slider":
	case "deck":
		return isStory ? "slide" : "deck";
	case "multislider":
		return isStory ? "slide" : "multislider";
	case "featured":
		return "loose";
	case "slide":
	case "box":
	case "tile":
	case "loose":
	case "primary":
	case "secondary":
	case "tertiary":
		return style;
	default:
		return null;
	}
}

export function normalizeOptions(publishable: Publishable, itemoptions?: PublishableOptions): Options {
	const options = Object.assign({}, publishable.options, itemoptions);
	options.style = normalizeStyle(publishable.type, options.style);
	return options;
}

export function isTiledItem(item: PositionItem, style?: ?string) {
	if (item.type === "snippet") { return item.options.inline === true; }
	if (item.type !== "publishable") { return false; }
	switch (style || item.options.style) {
	case "tile":
	case "loose":
	case "primary":
	case "secondary":
	case "tertiary":
		return true;
	default:
		return false;
	}
}

export function shouldLoadChildren(item: ItemPublishable, ifNoStyle: boolean = true) {
	const {options, content, type} = item;
	if (type === 'pagenav' || content.type === "story" || content.type === "link") { return false; }
	const {style} = options;
	return ifNoStyle && !style || isMultipleItemStyle(style);
}

export function isMultipleItemStyle(style) {
	return style === 'section' || style === 'deck' || style === 'slider' || style === 'multislider'
}



// WEBPACK FOOTER //
// ./lib/api/items.js